import './TextPreview.scss';

export { default } from './TextPreview';
